import React from 'react';
import styles from './TextInput.styl';

class TextInput extends React.Component
{
	render() {

		const style = {
			left:  `${this.props.x}px`,
			top:   `${this.props.y}px`,
			width: `${this.props.width}px`,
		};

		if (!this.props.label)
		{
			style.position = 'absolute';

			return (
				<input
					className={styles.input}
					style={style}
					type="text"
					value={this.props.value}
					onChange={e => this.props.onChange(e.target.value)}
				/>
			);
		}

		return (
			<label className={styles.label} style={style}>

				<span className={styles.labelText}>{this.props.label}</span>

				<input
					className={styles.input}
					type="text"
					value={this.props.value}
					onChange={e => this.props.onChange(e.target.value)}
				/>

			</label>
		);
	}
}

export default TextInput;



// WEBPACK FOOTER //
// ./src/react/ui/TextInput.jsx